// extracted by mini-css-extract-plugin
export default {"loader":"full-screen-loader_loader__T1qpW"};